import { useNavigator } from '@repo/toolkit/use-navigator'
import { Column } from '@repo/ui/data-table'
import { PlusIcon, SettingIcon } from '@repo/ui/icons'
import { useRef } from 'react'

import { API } from '../../../api/apis.config'
import DynamicDataTable, { DynamicTableRef } from '../../../components/elements/dynamic-table'
import UserNavBar from '../../../components/elements/nav-bar'
import { Paths } from '../../../lib/constants/path'
import { medicalConditionEnumMapping } from '../../../lib/types/enums/enrollment/medical-condition-enum'
import { MedicalTerm } from '../../../lib/types/models/medical-terms/medical-term'

const MedicalTermListPage = () => {
  const tableRef = useRef<DynamicTableRef<MedicalTerm>>(null)
  const { navigate, navigateWithEvent } = useNavigator()

  const columns: Column<MedicalTerm>[] = [
    {
      accessorKey: 'label',
      header: 'Label',
      enableSorting: true
    },
    {
      accessorKey: 'level',
      header: 'Niveau',
      enableSorting: true,
      cell: (data) => medicalConditionEnumMapping[data.row.original.level].label
    },
    {
      accessorKey: 'value',
      header: 'Liste des mots qui déclenche la détection de ce terme',
      enableSorting: true,
      cell: (data) => data.row.original.value.join(', ')
    }
  ]

  return (
    <div>
      <UserNavBar title="Termes médicaux" icon={SettingIcon} />
      <div className="h-4" />
      <DynamicDataTable<MedicalTerm>
        ref={tableRef}
        title="Termes médicaux"
        columns={columns}
        deleteMessage={{ name: 'label', attributeName: 'label' }}
        selectable
        allowSearchParam
        endpoint={API.medicalTerms.getAll.url}
        onRowClick={(data, event) =>
          navigateWithEvent(
            Paths.MEDICAL_TERM_UPDATE_PAGE.replace(':id', data.id.toString()),
            event
          )
        }
        actions={[
          {
            type: 'global',
            icon: PlusIcon,
            label: 'Créer Termes médicaux',
            fn: () => navigate(Paths.MEDICAL_TERM_CREATE_PAGE)
          }
        ]}
      />
    </div>
  )
}

export default MedicalTermListPage
